import React, { useEffect, useState } from 'react';
import app from './firebaseConfig';
import RinkMap from './RinkMap';
import { getFirestore, doc, getDoc } from 'firebase/firestore';
import { useTheme } from './hooks/useTheme';

function MapViewer({ type = 'rink' }) {
    const [data, setData] = useState([]);
    const apiKey = 'AIzaSyCY7tnMWTt69m0AsmBNjpcJnwoMFylPJxI';
    const { theme, toggleTheme } = useTheme();

    useEffect(() => {
        // Function to fetch data from Firestore
        const fetchData = async () => {
            const db = getFirestore(app);
            const collectionName = type === 'trail' ? 'aggregatedskitrails' : 'aggregatedrinks';
            const docRef = doc(db, collectionName, "data");

            try {
                const docSnap = await getDoc(docRef);

                if (docSnap.exists()) {
                    console.log(`${type} data:`, docSnap.data());
                    if (type === 'trail') {
                        const docData = docSnap.data();
                        // Try to find the correct array field for trails
                        if (docData.piste) {
                            setData(docData.piste);
                        } else if (docData.trails) {
                            setData(docData.trails);
                        } else if (docData.patinoire) {
                            // Fallback if they reused the structure name
                            setData(docData.patinoire);
                        } else {
                            // Fallback: use the first array value found in the object
                            const firstArray = Object.values(docData).find(val => Array.isArray(val));
                            if (firstArray) {
                                setData(firstArray);
                            } else {
                                console.warn("No array found in ski trails document");
                            }
                        }
                    } else {
                        setData(docSnap.data().patinoire);
                    }
                } else {
                    console.log("No such document!");
                }
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        };

        fetchData();
    }, [type]);

    return (
        <div className="App">
            <RinkMap
                rinks={data}
                apiKey={apiKey}
                theme={theme}
                toggleTheme={toggleTheme}
                type={type}
            />
        </div>
    );
}

export default MapViewer;
